import { useEffect, useRef } from 'react';
export const useEscapeKeydown = onEscapeKeyDown => {
  const onEscapeKeyDownRef = useRef(onEscapeKeyDown);
  onEscapeKeyDownRef.current = onEscapeKeyDown;
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        onEscapeKeyDownRef.current?.(e);
      }
    };
    document.addEventListener('keydown', handleKeyDown, {
      capture: true
    });
    return () => document.removeEventListener('keydown', handleKeyDown, {
      capture: true
    });
  }, []);
};